setPmSectionDoneAction